export default __webpack_public_path__ + "static/media/social_icon_laos.8e8ff440.jpg";